// extracted by mini-css-extract-plugin
export var arrow = "index-module--arrow--020a5";
export var arrowLogo = "index-module--arrowLogo--09913";
export var arrowText = "index-module--arrowText--e7ed3";
export var columnText = "index-module--columnText--11bc0";
export var disabled = "index-module--disabled--0609b";
export var numberText = "index-module--numberText--2191e";
export var pageNumbers = "index-module--pageNumbers--857e5";
export var root = "index-module--root--2d6a7";
export var selectNumberText = "index-module--selectNumberText--3fd61";